const shortname = (value) => {
  return value.length > 20 ? value.slice(0, 20) + '...' : value
}

const convertMonth = (value, lang = 'th', type) => {
  let month = parseInt(value.split('-')[1])
  let year = parseInt(value.split('-')[0])
  let date = parseInt(value.split('-')[0])
  let data = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  if (lang == 'th') {
    year = year + 543
    data = [
      '',
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม'
    ]
  }
  return type == 'y' ? year : type == 'm' ? data[month] : date
}

const toTwoDigit = (value) => {
  let convertData
  const toKiloMeters = value / 1000
  if (toKiloMeters >= 1) {
    convertData = parseInt(toKiloMeters) + 'km.'
  } else {
    convertData = (value % 1000) + 'm.'
  }
  return convertData
}

export default {
  shortname: shortname,
  convertMonth: convertMonth,
  toTwoDigit: toTwoDigit
}
